import { render, staticRenderFns } from "./DevicesTab.vue?vue&type=template&id=185a9c89&scoped=true"
import script from "./DevicesTab.vue?vue&type=script&lang=js"
export * from "./DevicesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a9c89",
  null
  
)

export default component.exports